import { render, staticRenderFns } from "./BandejaCambiarEstatusIncompletosComponente.vue?vue&type=template&id=13152124"
import script from "./BandejaCambiarEstatusIncompletosComponente.vue?vue&type=script&lang=js"
export * from "./BandejaCambiarEstatusIncompletosComponente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports